import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '@narvar/nth-text-input';
import { extractNumber, obfuscateNumber, formatNumber } from '../../lib/phone';

const TelephoneInput = ({ value, onChange, onFocus, onBlur, placeholder }) => {
  const [number, setNumber] = React.useState(value);
  const [displayedNumber, setDisplayedNumber] = React.useState(
    value.length === 10 ? obfuscateNumber(value) : formatNumber(value),
  );

  const onInputChange = ({ target: { value: newValue = '' } }) => {
    let newNumber = extractNumber(newValue);

    if (newNumber.length > 10) {
      newNumber = newNumber.substr(0, 10);
    }

    onChange(newNumber);
    setNumber(newNumber);
    setDisplayedNumber(formatNumber(newNumber));
  };

  const onInputFocus = () => {
    onFocus();
    setDisplayedNumber(formatNumber(number));
  };

  const onInputBlur = () => {
    onBlur();
    if (number.length === 10) {
      setDisplayedNumber(obfuscateNumber(number));
    }
  };

  return (
    <TextInput
      className="fs-exclude"
      type="tel"
      value={displayedNumber}
      onChange={onInputChange}
      placeholder={placeholder}
      s={{
        borderColor: '#cccccc',
        height: '2.5rem',
      }}
      onFocus={onInputFocus}
      onBlur={onInputBlur}
      maxLength={14}
    />
  );
};

TelephoneInput.defaultProps = {
  onFocus: () => {},
  onBlur: () => {},
  placeholder: '',
};

TelephoneInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
};

export default TelephoneInput;
